import { useTheme, type SxProps, type Theme } from '@mui/material/styles';
import { ReactNode } from 'react';
import SharedSvg from '../../shared/shared-svg';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface FlaggedSectionHeaderProps {
  title: string;
  titleVariant: 'h5' | 'subtitle2';
  titleSx?: SxProps<Theme>;
  helperText: ReactNode;
  helperTextSx?: SxProps<Theme>;
  flagTestId?: string;
}

export default function FlaggedSectionHeader({
  title,
  titleVariant,
  titleSx,
  helperText,
  helperTextSx,
  flagTestId,
}: FlaggedSectionHeaderProps) {
  const theme = useTheme();

  return (
    <Box>
      <Stack direction="row" spacing={0.75} alignItems="center">
        <SharedSvg
          data-testid={flagTestId}
          variant="red"
          width={16}
          height={16}
        />
        <Typography variant={titleVariant} sx={titleSx}>
          {title}
        </Typography>
      </Stack>
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.semantic.text.support,
          ml: '22px',
          ...helperTextSx,
        }}
      >
        {helperText}
      </Typography>
    </Box>
  );
}
